export const status = [
  { value: "active", label: "Active", color: "bg-green-500" },
  { value: "inactive", label: "Inactive", color: "bg-blue-500" },
];

export const userStatus = [
  { value: "active", label: "Active", color: "bg-green-500" },
  { value: "inactive", label: "Inactive", color: "bg-blue-500" },
  { value: "pending", label: "Pending", color: "bg-orange-500", hide: true },
];

export const walletTransactionStatus = [
  { value: "pending", label: "Pending", color: "bg-orange-500" },
  { value: "approved", label: "Approved", color: "bg-green-500" },
  { value: "rejected", label: "Rejected", color: "bg-red-500", hide: true },
];

export const invoiceType = [
  { label: "Proforma", value: "Proforma" },
  { label: "Invoice", value: "Invoice" },
];

export const invoiceStatus = [
  { label: "Paid", value: "Paid" },
  { label: "Pending", value: "Pending" },
  { label: "Processing", value: "Processing" },
  { label: "Refunded", value: "Refunded" },
  { label: "Cancelled", value: "Cancelled" },
];
